import moment from 'moment'
import React,{useState,useEffect,useRef} from 'react'
import { assetUrl } from '../../helpers'
import { FR } from '../../sdk'
import { Loader } from '../Default'
import { toasterFunction } from '../Default/ToasterComponent'
import { DataTable2 } from '../Default/DataTables/DataTable2'
import { useAuthContext } from '../../context/Auth/Create'

export const MainContent=()=> {
  const userAuth=useAuthContext()
  const tbHeader=[
  // {title:"Employee ID",name:"Employee ID"},{title:"Name",name:"name"},{title:"CompanyName",name:"name"},{title:"Department Name",name:"name"},{title:"Designation Name",name:"name"},{title:"TypeName",name:"name"},{title:"Business Unit Name",name:"name"},{title:"Is Active",name:"name"},{title:"Required Days",name:"Image"},{title:"Start Time",name:"Image"},{title:"End Time",name:"Image"},{title:"Image",name:"Image"},{title:"Operations",name:"operations"}]
  {title:"Employee ID",name:"Employee ID",data:"employeeId"},
  {title:"Name",data:"firstName",render:function(data,type,row){
    return `${row.firstName} ${row.middleName} ${row.lastName}`
  }},{title:"Company Name",data:"employeeId",render:function(data,type,row){
    return row.companyName?row.companyName:"N/A"
}},{title:"Department",data:"employeeId",render:function(data,type,row){
  return row.departmentName?row.departmentName:"N/A"
}},{title:"Updated At",data:"employeeId",render:function(data,type,row){
      return row.tmsUpdatedOn?moment(row.tmsUpdatedOn).format("yyyy-MM-DD hh:mm:ss"):""
  }},

{title:"Image",data:"employeeId",render:function(data,type,row){
    return row.frontImageUrl?`<div id="" style="display: none;">${assetUrl}${row.frontImageUrl}</div><img src=${assetUrl}${row.frontImageUrl} style="width:100%;max-height:100px" />`:"no image";
  }},{title:"Operations",data:"employeeId",render:function(data,type,row){
    return `<button type="button" class="btn btn-danger delete" data-index=${row.employeeId} data-id=${row.employeeId} style="display:none"><i class="fa fa-trash" aria-hidden="true"></i>${row.frontImageUrl?`<button type="button" class="btn btn-default update me-2" data-index=${row.employeeId} data-id=${row.employeeId}>Update</button>`:""}${!row.frontImageUrl?`<button type="button" class="btn btn-default add_images" data-index=${row.employeeId} data-id=${row.employeeId}>Add Images</button>`:`<button type="button" class="btn btn-default update_image" data-modal="#update-images" data-index=${row.employeeId} data-id=${row.employeeId}>Update Images</button>`}`
  }},


]
const [state,setState]=useState({loader:true,date:moment().format("yyyy-MM-DD"),actualData:[],data:[],
tbHeader,
updated:false,
tableLoader:false,
buttonLoader:false,
buttonDisabled:false,
departments:[],
subDepartments:[],
count:1,
status:0,
tableLoader2:true,
imageViewer:{
add:{
  frontImage:"",
  randomImage:"",
  leftImage:"",
  rightImage:"",
},
edit:{
  frontImage:"",
  randomImage:"",
  leftImage:"",
  rightImage:"",
},

},
formAttr:{
  firstName:"",
  lastName:"",
  employeeId:"",
  departmentId:"",
  subDepartmentId:"",
  subDepartmentName:"",
  frontImage:{},
  randomImage:{},
  leftImage:{},
  rightImage:{},
  images:[]
},
updateFormAttr:{
  firstName:"",
  lastName:"",
  employeeId:"",
  departmentId:"",
  subDepartmentId:"",
  subDepartmentName:"",
  frontImage:{},
  randomImage:{},
  leftImage:{},
  rightImage:{},
  requiredDays:0,
  startTime:"",
  endTime:"",
  departmentName:"",
  requiredHoursDay:0,
  requiredMints:0,
  id:0,
  index:0,
  images:[]
},
images:[],
deleteImages:[],
});

  const ref=useRef();
  const ref2=useRef();
  const ref3=useRef();
  const ref4=useRef({
    status:0,
    companyName:userAuth.user.isHightAuthority?userAuth?.user.companyName:"",
    department:"",
    dataTable1Params:{
      draw:1,
      start:0,
      length:0,
      search:"",
      order:"",
      columns:"",
      sort:"asc",
      actualData:[]
    },
   });
const onHandler=(event)=>{
    let key=event.target.name;
    let value=event.target.value;
    let oldState={...state}
    if(key==="frontImage" || key==="randomImage" || key==="leftImage" || key==="rightImage"){
      oldState.imageViewer.add[`${key}`]=URL.createObjectURL(event.target.files[0]);
      oldState.formAttr[key]=event.target.files[0];
    }
    else if(key==="departmentId"){
       let department=oldState.departments.find(val=>val.id===value);
       oldState.subDepartments=department ?department.subDept:[];
       oldState.formAttr[key]=value;    
    }
    else{
      if(key==="subDepartmentId"){
       oldState.formAttr["subDepartmentName"]=state.subDepartments.find(val=>val.id===value).name;
      }
      oldState.formAttr[key]=value;
    }
     
    setState((pre)=>{
      return {...pre,...oldState}
    })
    
  }
  const onHandlerMultiImages=(event)=>{
    let files = Array.from(event.target.files); 
    let images = files.map((file) => URL.createObjectURL(file));
    let id=event.target.id;
    if(id==="randomfile1"){
      setState((prevState) => ({
        ...prevState,
        formAttr: {
          ...prevState.formAttr,
          images: [...prevState.formAttr.images, ...files], 
        },
        images: [...prevState.images, ...images], 
      }));
    }
    else{
      setState((prevState) => ({
        ...prevState,
        updateFormAttr: {
          ...prevState.updateFormAttr,
          images: [...prevState.updateFormAttr.images, ...files], 
        },
        images: [...prevState.images, ...images], 
      }));
    }
   
    
}
const removeImage = (index,update=false,imageName=undefined,imageL=0) => {
  console.log(imageL)
  if(update){
    setState((prevState) => {
      const updatedImages = prevState.images.filter((_, i) => i !== index);
      const updatedFormAttrImages = prevState.updateFormAttr.images;
      let deleteImages= prevState.deleteImages;
      if(imageName){
       deleteImages.push(imageName);
       
      }
      else{
      prevState.updateFormAttr.images.filter((_, i) => i !== imageL);
      }
      
      return {
        ...prevState,
        images: updatedImages,
        updateFormAttr: {
          ...prevState.updateFormAttr,
          images: updatedFormAttrImages
        },
        deleteImages
      };
    });
  }
  else{
    setState((prevState) => {
      const updatedImages = prevState.images.filter((_, i) => i !== index);
      const updatedFormAttrImages = prevState.formAttr.images.filter((_, i) => i !== index);
      
      return {
        ...prevState,
        images: updatedImages,
        formAttr: {
          ...prevState.updateFormAttr,
          images: updatedFormAttrImages
        },
      };
    });
  }
    
};
const onSubmitUpdateWithMultiple=async (event)=>{
  event.preventDefault();
  
if(state.images.length < 4){
toasterFunction.error("Please upload at least 4 images");
return;
  } 
  ref.current.disabled=true;
  ref.current.firstElementChild.style.display="inline-block"
 try{
let images=state.updateFormAttr.images.filter(val=>{
  
  return val instanceof File 
})

await new FR().updatedImagesWithMultiple({...state.updateFormAttr,images,deleteImages:state.deleteImages});
toasterFunction.success("user images has been updated");
window.location.reload(); 

}catch(e){
 console.log(e)
if(e.response.status===300){
  toasterFunction.error("Employee already taken")
}
else{
  Object.values(e.response.data)[0].forEach(val=>{
    toasterFunction.error(val)
  })
  
}
ref.current.disabled=false;
ref.current.firstElementChild.style.display="none"
}finally{
  ref.current.disabled=false;
ref.current.firstElementChild.style.display="none"
}
}
const onUpdateHandler=(event)=>{
    let key=event.target.name;
    let value=event.target.value;
    let oldState={...state}
    if(key==="frontImage" || key==="randomImage" || key==="leftImage" || key==="rightImage"){
      oldState.imageViewer.edit[`${key}`]=URL.createObjectURL(event.target.files[0]);
      oldState.updateFormAttr[key]=event.target.files[0];
    }
    else if(key==="departmentId"){
       let department=oldState.departments.find(val=>val.id===value);
       oldState.subDepartments=department ?department.subDept:[];
       oldState.updateFormAttr[key]=value;    
    }
    
    else{
      if(key==="subDepartmentId"){
       oldState.updateFormAttr["subDepartmentName"]=state.subDepartments.find(val=>val.id===value).name;
      }
      oldState.updateFormAttr[key]=value;
    }
    setState((pre)=>{
      return {...pre,...oldState}
    })
    
  }
const apiData=async()=>{
    try{
    let users=await new FR().getCompanies();
    let departments=[]
		let find=users.find(val=>val.companyName===state.companyName);
			if(find){
			 departments=find.departments;
			}
		
		setState((pre)=>{
		  return {...pre,companies:users,loader:false,departments}
	   })
   }catch(e){
    console.log(e)
    alert("error occur")
    }

}

const apiData2WithPagination = async (data,callBack,status=ref4.current.status=ref4.current.status,companyName=ref4.current.companyName,department=ref4.current.department) => {
  try {
    setState((pre)=>{
      return {...pre,tableLoader:true}
    })
   
      
    let apiData = {
      draw:data?.draw,
      start:data?.start,
      length:data?.length,
      search:data?.search?.value || "",
      order:data?.order,
      columns:data?.columns,
      sort:data?.sort,
      status,
      companyName,
      department
            
    }
    
    let users=await new FR().getAllDataWithPagination({...apiData});
    ref4.current={...ref4.current,status,dataTable1Params:{
      draw:data?.draw,
      start:data?.start,
      length:data?.length,
      search:data?.search?.value || "",
      order:data?.order,
      columns:data?.columns,
      sort:data?.sort,
      actualData:users.data
    },
    callBack
    }
    ref4.current.callBack(users);
   

    setState((pre)=>{
      return {...pre,tableLoader:false,actualData:users.data}
     })
  } catch (e) {
    console.log(e)
    alert("error occur")
  }

}
const onDelete=async(id,index)=>{
  try{
    if(window.confirm("are you want to delete this")){
      await new FR().delete(id.toString());
      toasterFunction.success("user has been deleted")
      window.location.reload();
    }
   
  }catch(e){
  
  }
  }
const onUpdate=(id,index)=>{
  let data=ref4.current.dataTable1Params.actualData.find(val=> val.employeeId===String(id));

// console.log(data)
 if(data){
  let oldState={...state};
  oldState.updateFormAttr={...oldState.updateFormAttr,employeeId:data.employeeId,firstName:data.firstName,lastName:data.lastName,startTime:data.startTime,endTime:data.endTime,requiredDays:data.requiredDays,id,index,requiredHoursDay:data.requiredHoursDay,requiredMints:data.requiredMints,departmentName:data.departmentName?data.departmentName:""};
  // console.log(oldState)
  // let department=oldState.departments.find(val=>val.id===data.department);
  // oldState.subDepartments=department ?department.subDept:[];
  window.$("#showEditForm").modal("show")
  setState((pre)=>{
    return {...pre,...oldState}
  })
 }
//  else{
//   alert("data not found")
//  }
  
}
const modalHandler=()=>{
  const oldState={...state};
  oldState.formAttr={
    ...oldState.formAttr,
    firstName:"",
    lastName:"",
    employeeId:"",
    departmentId:"",
    subDepartmentId:"",
    subDepartmentName:"",
    frontImage:{},
    randomImage:{},
    leftImage:{},
    rightImage:{},
  };
  oldState.add={ 
  frontImage:"",
  randomImage:"",
  leftImage:"",
  rightImage:"",
}
setState((pre)=>{
  return{...pre,...oldState}
})
window.$("#showForm").modal("show")
}
const onSubmitAdd=async (event)=>{
  event.preventDefault();
  if(Object.keys(state.formAttr.frontImage).length){
    toasterFunction.error("front image require");
    return false;
  }
  if(Object.keys(state.formAttr.randomImage).length){
    toasterFunction.error("random image require");
    return false;
  }
  if(Object.keys(state.formAttr.leftImage).length){
    toasterFunction.error("left image require");
    return false;
  }
  if(Object.keys(state.formAttr.rightImage).length){
    toasterFunction.error("right image require");
    return false;
  }
   ref3.current.disabled=true;
  ref3.current.firstElementChild.style.display="inline-block"
 try{
let result=await new FR().addOld(state.formAttr);

let oldState={...state};
toasterFunction.success("user has been added");
let oldData=oldState.data;
window.location.reload(); 
oldData.push([result.employeeId,`${result.firstName} ${result.lastName}`,`<img src=${process.env.REACT_APP_SERVER_ASSET_URL}${result.frontImageUrl} style="width:100%;height:140px />`]);
oldState.data=oldData;
oldState.actualData.push(result);
oldState.count=oldState.count +1;
ref.current.disabled=false;
ref.current.firstElementChild.style.display="none"
window.$(".modal").modal("hide");
setState((pre)=>{
  return {...pre,...oldState}
})

}catch(e){
 
if(e.response.status===300){
  toasterFunction.error("Employee already taken")
}
else{
  toasterFunction.error(Object.values(e.response.data)[0][0])
}
ref3.current.disabled=false;
ref3.current.firstElementChild.style.display="none"
}
}
// const onSubmitAdd=async (event)=>{
//   event.preventDefault();
  
//   if(state.formAttr.images.length < 4){
//   toasterFunction.error("Please upload at least 4 images");
//   return;
//   } 
//   ref3.current.disabled=true;
//   ref3.current.firstElementChild.style.display="inline-block"
//  try{
// await new FR().add(state.formAttr);
// toasterFunction.success("user has been added");
// //window.location.reload(); 
// }catch(e){
 
// if(e.response.status===300){
//   toasterFunction.error("Employee already taken")
// }

// else{
 
//   Object.values(e.response.data).forEach(val=>{
//     toasterFunction.error(val)
//   })
  
// }
// ref3.current.disabled=false;
// ref3.current.firstElementChild.style.display="none"
// }
// }
const onSubmitUpdate=async (event)=>{
  event.preventDefault();
  ref2.current.disabled=true;
  ref2.current.firstElementChild.style.display="inline-block"
 
try{
await new FR().updateEmployee({...state.updateFormAttr,id:String(state.updateFormAttr)});
toasterFunction.success("user has been updated");
window.location.reload(); 
// ref2.current.disabled=false;
// ref2.current.firstElementChild.style.display="none"
// oldState.data=oldState.data.map(val=>{
// if(Number(state.updateFormAttr.index)===Number(val[0])){
//  return [ val[0].employeeID,result.name,result.department,`<button type="button" class="btn btn-danger delete" data-index=${val[0]}  data-id=${result.id}><i class="fa fa-trash" aria-hidden="true"></i></button> <button type="button" class="btn btn-default update" data-index=${oldState.count} data-id=${result.id}><i class="fa fa-pencil" aria-hidden="true"></i></button>`]
// }
// else{
//   return val
// }
// });
// oldState.actualData=oldState.actualData.map(val=>{
// if(Number(state.updateFormAttr.id) !== Number(val.id)){
//   return val;
// }
// else{
//   return result;
// }
// });
// window.$(".modal").modal("hide");
// setState((pre)=>{
//   return {...pre,...oldState}
// })

}catch(e){
  
  if(e.response.status===300){
  toasterFunction.error("name already taken")
}
else{
  toasterFunction.error(e.response.data.message)
}
ref2.current.disabled=false;
ref2.current.firstElementChild.style.display="none"
}
}
const onUpdateImage=(id,index,modalId)=>{
  let data=ref4.current.dataTable1Params.actualData.find(val=> val.employeeId===String(id));
  
   if(data){
    let oldState={...state};

    let images=data.images??[].map((val)=>`${assetUrl}${val}`);
    oldState.updateFormAttr={...oldState.updateFormAttr,employeeId:data.employeeId,firstName:data.firstName,lastName:data.lastName,id,index,images};
    
    window.$("#update-images").modal("show")
    setState((pre)=>{
      return {...pre,...oldState,images,deleteImages:[]}
    })
   }
   else{
    alert("data not found")
   }
    
  }
const onAddImage=(id,index,modalId)=>{
    let data=ref4.current.dataTable1Params.actualData.find(val=> val.employeeId===String(id));
    
     if(data){
      let oldState={...state};
  
      let images=[];
      oldState.updateFormAttr={...oldState.updateFormAttr,employeeId:data.employeeId,firstName:data.firstName,lastName:data.lastName,id,index,images};
      
      window.$("#showImageEditForm").modal("show")
      setState((pre)=>{
        return {...pre,...oldState,images,deleteImages:[]}
      })
     }
     else{
      alert("data not found")
     }
      
    }
const onSubmitUpdateImages=async (event)=>{
    event.preventDefault();
    if(Object.keys(state.updateFormAttr.frontImage).length){
      toasterFunction.error("front image require");
      return false;
    }
    if(Object.keys(state.updateFormAttr.randomImage).length){
      toasterFunction.error("random image require");
      return false;
    }
    if(Object.keys(state.updateFormAttr.leftImage).length){
      toasterFunction.error("left image require");
      return false;
    }
    if(Object.keys(state.updateFormAttr.rightImage).length){
      toasterFunction.error("right image require");
      return false;
    }
     ref.current.disabled=true;
    ref.current.firstElementChild.style.display="inline-block"
   try{
  await new FR().updatedImages(state.updateFormAttr);
  toasterFunction.success("user has been Updated");
  window.location.reload(); 
 
  
  }catch(e){
   
  if(e.response.status===300){
    toasterFunction.error("Employee already taken")
  }
  else{
    Object.values(e.response.data)[0].forEach(val=>{
      toasterFunction.error(val)
    })
    
  }
  ref.current.disabled=false;
  ref.current.firstElementChild.style.display="none"
  }
  }
const handleFileChange = async(event) => {
  const selectedFile = event.target.files[0];
  if (selectedFile && selectedFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    await new FR().uploadFromExcel(selectedFile);
    window.location.reload();
   
  } else {
    console.error('Invalid file type. Please select an Excel file.');
  }
};
const onHandlerType=(event)=>{
 let key=event.target.name;
 let value=event.target.value;
 if(key==="companyName"){
 let departments=[];
 let find=state.companies.find(val=>val.companyName===value);
 if(find){
  departments=find.departments;
 }
 ref4.current={...ref4.current,[key]:value,department:""}
 setState((pre)=>{
   return{...pre,departments,department:""}
 })
 }
 else{
  ref4.current={...ref4.current,[key]:value}
  setState((pre)=>{
    return{...pre,[key]:value}
  })
 }
  //apiData2WithPagination({...ref4.current.dataTable1Params},ref4.current.callBack,event.target.value)
}
const numberOfPicsOnBackend=async(employeeId)=>{
  try{
    setState((pre)=>{
      return {...pre,tableLoader:true}
    });
    let result=await new FR().getImagesFromBackend(String(employeeId));
    window.$(`#${employeeId}_backendpics`).text(result.numberOfPicsOnBackend);
    toasterFunction.success("data has been feteched")

  }catch(e){
    Object.values(e.response.data)[0].forEach(val=>{
      toasterFunction.error(val)
    })
  }
  finally{
  
    setState((pre)=>{
      return {...pre,tableLoader:false}
    })
  }
}
const socketImageUploadingStart=(data)=>{
  console.log("imageUpload start",data);
  if(data.status===200){
    toasterFunction.success(data.data);
  }
  else{
    toasterFunction.error(data.data)
  }
  }
  useEffect(()=>{
    apiData();
    userAuth.socket.on('imageUploaded', socketImageUploadingStart);
    return ()=>{
      userAuth.socket.off('imageUploaded', socketImageUploadingStart);
    }
  },[])
useEffect(()=>{
apiData();
},[])
if(!state.loader){
  return (
    <>
      <div className="card mb-3">
       {/* BEGIN card-body */}
       <div className="card-body">
   <div className="col-12 mb-4">
     <div className="row" style={{textAlign:"center"}}>
       <div className="col-sm-3 col-md-3 col-lg-12 mb-4">
       <div className="fw-bold mb-3">
   <span className="flex-grow-1 text-white">All Employees</span>
   </div> 
       </div>
       <div className="col-2"></div>
       {/* <div className="col-1" style={{textAlign:"end"}}>
       <button type="button" onClick={()=>{
        uploadRef.current.click()
       }} class="btn btn-theme">Upload File</button>
      <input type={"file"} ref={uploadRef} style={{display:"none"}}  accept=".xlsx, .xls" 
        onChange={handleFileChange}/>
       </div> */}
         <div className="col-sm-3 col-md-3 col-lg-2">
      <div class="form-group mb-3">
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect1" ></label>
        <select class="form-select" name="companyName" id="exampleFormControlSelect1" onChange={onHandlerType} style={{color:"rgb(60, 210, 165)"}}>
          <option value="" selected={ref4.current.companyName===""}>Company</option>
          {state.companies.map((val,index)=>{
            return  <option key={index} value={val.companyName} selected={ref4.current.companyName===val.companyName}>{val.companyName}</option>
          })}
         
          
          </select>
          </div>
       </div>
       <div className="col-sm-3 col-md-3 col-lg-2">
      <div class="form-group mb-3">
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect2" ></label>
        <select class="form-select" name="department" id="exampleFormControlSelect2" onChange={onHandlerType} style={{color:"rgb(60, 210, 165)"}}>
        <option value="" selected={ref4.current.companyName===""}>Department</option>
          {state.departments.map((val,index)=>{
            return  <option key={index} value={val} selected={ref4.current.department===val}>{val}</option>
          })}
          </select>
          </div>
       </div>
       <div className="col-sm-3 col-md-3 col-lg-2">
      <div class="form-group mb-3">
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect3" ></label>
        <select class="form-select" name="status" id="exampleFormControlSelect3" onChange={onHandlerType} style={{color:"rgb(60, 210, 165)"}}>
          <option value="0" selected={state.status==0}>Type</option>
          <option value="1" selected={state.status==1}>Complete Registeration</option>
          <option value="2" selected={state.status==2}>incomplete Registeration</option>
          </select>
          </div>
       </div>
         <div className='col-sm-3 col-md-3 col-lg-2 search' >
                <label class="form-label" for="Location"></label>
                <br />
                <button type="button" class="btn btn-theme" onClick={()=>apiData2WithPagination({...ref4.current.dataTable1Params},ref4.current.callBack)}>Search</button>
              </div>
              {(userAuth.user && userAuth.user.permissions.includes("Add Employees(Fr)")) && <>  <div className="col-sm-3 col-md-3 col-lg-2 add-button" style={{textAlign:"end"}}>
       <button type="button" class="btn btn-theme" onClick={modalHandler}>Add new User</button>
       </div></>}
      
      
     </div>
  
   </div>
   {state.tableLoader && <><Loader/></>}
   
   <div className="col-12">
   {<DataTable2 headers={state.tbHeader} image={true}  reverse={true} count={"paginationTable3"} ajax={apiData2WithPagination} parentFun={{onUpdate,onDelete,onUpdateImage,numberOfPicsOnBackend,onAddImage}}/>}
  {/* <DataTable headers={state.tbHeader} data={state.data} image={true} updated={state.updated} parentFun={{onUpdate,onDelete,onUpdateImage}} reverse={true}/> */}
  
   </div>
   </div>
   <div className="card-arrow">
         <div className="card-arrow-top-left" />
         <div className="card-arrow-top-right" />
         <div className="card-arrow-bottom-left" />
         <div className="card-arrow-bottom-right" />
       </div>
   </div>
   
   <div class="modal" id="showForm">
  <div class="modal-dialog modal-xl">
    <div class="modal-content" style={{background:"rgb(4 24 18)"}}>
    
      <div class="modal-header">
        <h5 class="modal-title">Add New User</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div className="row">
          <div className="col-12">
           <form onSubmit={onSubmitAdd}>
          <div className="row">
          <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              First Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter First Name"
              name='firstName'
              value={state.formAttr.firstName}
              onChange={onHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Last Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Last Name"
              name='lastName'
              value={state.formAttr.lastName}
              onChange={onHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Employee ID
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Employee Id"
              name='employeeId'
              value={state.formAttr.employeeId}
              onChange={onHandler}
              required
            />
          </div>
        </div>
        
        {/* <div className="col-xl-6">
                                  <div class="form-group mb-3">
                                    <label class="form-label" for="exampleFormControlSelect1">Department</label>
                                    <select class="form-select" id="exampleFormControlSelect1" onChange={onHandler} name="departmentId" required>
                                      <option value="">Select Department</option>
                                      {state.departments.map((v,index)=>{
                                          return (<>
                                          <option key={index} value={v.id} selected={Number(v.id) ===Number(state.formAttr.departmentId)}>{v.name}</option>
                                          
                                          </>)
                                     })}
                                    </select>
                                  </div>
                                
                </div> */}
                {/* <div className="col-xl-6">
                                  <div class="form-group mb-3">
                                    <label class="form-label" for="exampleFormControlSelect1">Sub Department</label>
                                    <select class="form-select" id="exampleFormControlSelect1" onChange={onHandler} name="subDepartmentId" required>
                                      <option value="">Select SubDepartment</option>
                                      {state.subDepartments.map((v,index)=>{
                                          return (<>
                                          <option key={index} value={v.id} selected={Number(v.id) ===Number(state.formAttr.subDepartmentId)}>{v.name}</option>
                                          
                                          </>)
                                     })}
                                    </select>
                                  </div>
                                
                </div> */}
     
       <div className="col-xl-6"></div>
        <div className="col-xl-3">
                  <div className="row">
                    <div className="col-12">
                    <div class="mb-3">
														<label class="form-label" for="frontfile">Front Image</label>
														<input type="file" class="form-control" id="frontfile" name="frontImage" onChange={onHandler} accept="image/*"/>
													</div>
                    </div>
                    <div className="col-12">
                    <div class="mb-3">
													<img src={state.imageViewer.add.frontImage} alt={state.imageViewer.add.frontImage} style={{height: "auto",maxWidth:"260px"}}/>
													</div>
                    </div>
                  </div>
      
        </div>
        <div className="col-xl-3">
                  <div className="row">
                    <div className="col-12">
                    <div class="mb-3">
														<label class="form-label" for="randomfile">Random Image</label>
														<input type="file" class="form-control" id="randomfile" name="randomImage" onChange={onHandler} accept="image/*"/>
													</div>
                    </div>
                    <div className="col-12">
                    <div class="mb-3">
													<img src={state.imageViewer.add.randomImage} alt={state.imageViewer.add.randomImage} style={{height: "auto",maxWidth:"260px"}}/>
													</div>
                    </div>
                  </div>
      
        </div>
        <div className="col-xl-3">
                  <div className="row">
                    <div className="col-12">
                    <div class="mb-3">
														<label class="form-label" for="leftfile">Left Image</label>
														<input type="file" class="form-control" id="leftfile" name="leftImage" onChange={onHandler} accept="image/*"/>
													</div>
                    </div>
                    <div className="col-12">
                    <div class="mb-3">
													<img src={state.imageViewer.add.leftImage} alt={state.imageViewer.add.leftImage} style={{height: "auto",maxWidth:"260px"}}/>
													</div>
                    </div>
                  </div>
      
        </div>
        <div className="col-xl-3">
                  <div className="row">
                    <div className="col-12">
                    <div class="mb-3">
														<label class="form-label" for="leftfile">Right Image</label>
														<input type="file" class="form-control" id="rightfile" name="rightImage" onChange={onHandler} accept="image/*"/>
													</div>
                    </div>
                    <div className="col-12">
                    <div class="mb-3">
													<img src={state.imageViewer.add.rightImage} alt={state.imageViewer.add.rightImage} style={{height: "auto",maxWidth:"260px"}}/>
													</div>
                    </div>
                  </div>
      
        </div>
            
       {/* <div className="col-xl-12">
                  <div className="row">
                    <div className="col-6">
                    <div class="mb-3">
														<label class="form-label" htmlFor="randomfile1">Images</label>
                            
														<input type="file" class="form-control" id="randomfile1" name="images" onChange={onHandlerMultiImages} accept="image/*" multiple style={{display:"none"}}/>
                            <button type="button" class="btn btn-default" onClick={()=>window.$("#randomfile1").click()}>Upload</button>
                          </div>
                    </div>
                    <div className="col-12">
                  <div className="row">
                    {state.images.map((val,index)=>{
                      return <>
                    <div key={index} className="col-3 mb-2">
                      <i className="fas fa-lg fa-fw me-2 fa-trash" onClick={() => removeImage(index)} style={{color:"red",cursor:"pointer"}}></i>
                    <img  src={val} alt={val} style={{height: "260px",maxWidth:"260px"}}/>
                    </div>
                      </>
                    })}
                  
                  </div>
                    </div>
                  </div>
      
        </div> */}
       
          <div className="col-xl-12"style={{textAlign:"center"}}>
          <button type="submit" class="btn btn-outline-theme w-25" ref={ref3} disabled={false}>Add <div className="spinner-border" role="status" style={{height:"15px",width: "1rem" ,display:"none"}}></div></button>
          </div>
     
      </div>
    </form>
  </div>

        </div>
       </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default " data-bs-dismiss="modal">Close</button>
        
      </div>
    
     
     
    </div>
  </div>
</div>
<div class="modal" id="showEditForm">
<div class="modal-dialog modal-xl">
    <div class="modal-content" style={{background:"rgb(4 24 18)"}}>
    
      <div class="modal-header">
        <h5 class="modal-title">Edit User</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div className="row">
          <div className="col-12">
           <form onSubmit={onSubmitUpdate}>
          <div className="row">
          <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              First Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter First Name"
              name='firstName'
              value={state.updateFormAttr.firstName}
              onChange={onUpdateHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Last Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Last Name"
              name='lastName'
              value={state.updateFormAttr.lastName}
              onChange={onUpdateHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Employee ID
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Employee Id"
              name='employeeId'
              value={state.updateFormAttr.employeeId}
              onChange={onUpdateHandler}
              required
              disabled
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Department Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Department Name"
              name='departmentName'
              value={state.updateFormAttr.departmentName}
              onChange={onUpdateHandler}
              required
              
            />
          </div>
        </div>
        
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Required Days
            </label>
            <input
              type="number"
              className="form-control"
              placeholder="Enter Required Days"
              name='requiredDays'
              value={state.updateFormAttr.requiredDays}
              onChange={onUpdateHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Required Hours
            </label>
            <input
              type="number"
              className="form-control"
              placeholder="Enter Required Hours"
              name='requiredHoursDay'
              min={0}
              max={23}
              value={state.updateFormAttr.requiredHoursDay}
              onChange={onUpdateHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
          Required Mintues
            </label>
            <input
              type="number"
              className="form-control"
              placeholder="Enter Required Mintues"
              name='requiredMints'
              value={state.updateFormAttr.requiredMints}
              onChange={onUpdateHandler}
              min={0}
              max={59}
              required
            />
          </div>
        </div>
          <div className="col-xl-12"style={{textAlign:"center"}}>
          <button type="submit" class="btn btn-outline-theme w-25" ref={ref2} disabled={false}>Edit <div className="spinner-border" role="status" style={{height:"15px",width: "1rem" ,display:"none"}}></div></button>
          </div>
     
      </div>
    </form>
  </div>

        </div>
       </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default " data-bs-dismiss="modal">Close</button>
        
      </div>
    
     
     
    </div>
  </div>
</div>
<div class="modal" id="showImageEditForm">
  <div class="modal-dialog modal-xl">
    <div class="modal-content" style={{background:"rgb(4 24 18)"}}>
   
      <div class="modal-header">
        <h5 class="modal-title">Add Images</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div className="row">
          <div className="col-12">
           <form onSubmit={onSubmitUpdateImages}>
          <div className="row">
          <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              First Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter First Name"
              name='firstName'
              value={state.updateFormAttr.firstName}
              onChange={onHandler}
              required
              disabled
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Last Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Last Name"
              name='lastName'
              value={state.updateFormAttr.lastName}
              onChange={onHandler}
              required
              disabled
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Employee ID
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Employee Id"
              name='employeeId'
              value={state.updateFormAttr.employeeId}
              onChange={onHandler}
              required
              disabled
            />
          </div>
        </div>
        
      
     
       <div className="col-xl-6"></div>
            
        <div className="col-xl-3">
                  <div className="row">
                    <div className="col-12">
                    <div class="mb-3">
														<label class="form-label" for="frontfile">Front Image</label>
														<input type="file" class="form-control" id="frontfile" name="frontImage" onChange={onUpdateHandler} accept="image/*"/>
													</div>
                    </div>
                    <div className="col-12">
                    <div class="mb-3">
													<img src={state.imageViewer.edit.frontImage} alt={state.imageViewer.edit.frontImage} style={{height: "auto",maxWidth:"260px"}}/>
													</div>
                    </div>
                  </div>
      
        </div>
        <div className="col-xl-3">
                  <div className="row">
                    <div className="col-12">
                    <div class="mb-3">
														<label class="form-label" for="randomfile">Random Image</label>
														<input type="file" class="form-control" id="randomfile" name="randomImage" onChange={onUpdateHandler} accept="image/*"/>
													</div>
                    </div>
                    <div className="col-12">
                    <div class="mb-3">
													<img src={state.imageViewer.edit.randomImage} alt={state.imageViewer.edit.randomImage} style={{height: "auto",maxWidth:"260px"}}/>
													</div>
                    </div>
                  </div>
      
        </div>
        <div className="col-xl-3">
                  <div className="row">
                    <div className="col-12">
                    <div class="mb-3">
														<label class="form-label" for="leftfile">Left Image</label>
														<input type="file" class="form-control" id="leftfile" name="leftImage" onChange={onUpdateHandler} accept="image/*"/>
													</div>
                    </div>
                    <div className="col-12">
                    <div class="mb-3">
													<img src={state.imageViewer.edit.leftImage} alt={state.imageViewer.edit.leftImage} style={{height: "auto",maxWidth:"260px"}}/>
													</div>
                    </div>
                  </div>
      
        </div>
        <div className="col-xl-3">
                  <div className="row">
                    <div className="col-12">
                    <div class="mb-3">
														<label class="form-label" for="leftfile">Right Image</label>
														<input type="file" class="form-control" id="rightfile" name="rightImage" onChange={onUpdateHandler} accept="image/*"/>
													</div>
                    </div>
                    <div className="col-12">
                    <div class="mb-3">
													<img src={state.imageViewer.edit.rightImage} alt={state.imageViewer.edit.rightImage} style={{height: "auto",maxWidth:"260px"}}/>
													</div>
                    </div>
                  </div>
      
        </div>
        {/* <div className="col-xl-12">
                  <div className="row">
                    <div className="col-6">
                    <div class="mb-3">
														<label class="form-label" htmlFor="randomfile">Images</label>
                            
														<input type="file" class="form-control" id="randomfile" name="images" onChange={onHandlerMultiImages} accept="image/*" multiple style={{display:"none"}}/>
                            <button type="button" class="btn btn-default" onClick={()=>window.$("#randomfile").click()}>Upload</button>
                          </div>
                    </div>
                    <div className="col-12">
                  <div className="row">
                    {state.images.map((val,index)=>{
                      let imageName;
                      if(!val.startsWith('blob:')){
                        let splitValue=val.split("/");
                        if(splitValue.length){
                              splitValue=splitValue[splitValue.length -1];
                              imageName=splitValue.split(".jpg")[0];

                        }
                      }
                      return <>
                    <div key={index} className="col-3 mb-2">
                      <i className="fas fa-lg fa-fw me-2 fa-trash" onClick={() => removeImage(index,true,imageName)} style={{color:"red",cursor:"pointer"}}></i>
                    <img  src={val} alt={val} style={{height: "260px",maxWidth:"260px"}}/>
                    </div>
                      </>
                    })}
                  
                  </div>
                    </div>
                  </div>
      
        </div> */}
          <div className="col-xl-12"style={{textAlign:"center"}}>
          <button type="submit" class="btn btn-outline-theme w-25" ref={ref} disabled={false}>Add<div className="spinner-border" role="status" style={{height:"15px",width: "1rem" ,display:"none"}}></div></button>
          </div>
     
      </div>
    </form>
  </div>

        </div>
       </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default " data-bs-dismiss="modal">Close</button>
        
      </div>
    </div>
     
     
    
  </div>
</div>
<div class="modal" id="update-images">
  <div class="modal-dialog modal-xl">
    <div class="modal-content" style={{background:"rgb(4 24 18)"}}>
   
      <div class="modal-header">
        <h5 class="modal-title">Update Images</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div className="row">
          <div className="col-12">
           <form onSubmit={onSubmitUpdateWithMultiple}>
          <div className="row">
          <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              First Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter First Name"
              name='firstName'
              value={state.updateFormAttr.firstName}
              onChange={onHandler}
              required
              disabled
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Last Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Last Name"
              name='lastName'
              value={state.updateFormAttr.lastName}
              onChange={onHandler}
              required
              disabled
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Employee ID
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Employee Id"
              name='employeeId'
              value={state.updateFormAttr.employeeId}
              onChange={onHandler}
              required
              disabled
            />
          </div>
        </div>
        
      
     
       <div className="col-xl-6"></div>
            
       
        <div className="col-xl-12">
                  <div className="row">
                    <div className="col-6">
                    <div class="mb-3">
														<label class="form-label" htmlFor="randomfile2">Images</label>
                            
														<input type="file" class="form-control" id="randomfile2" name="images" onChange={onHandlerMultiImages} accept="image/*" multiple style={{display:"none"}}/>
                            <button type="button" class="btn btn-default" onClick={()=>window.$("#randomfile2").click()}>Upload</button>
                          </div>
                    </div>
                    <div className="col-12">
                  <div className="row">
                  {
                    
                  state.images.map((val,index)=>{
                      let imageName;
                      let imageUrlWith=val;
                      
                      if(!val.startsWith('blob:')){
                        let splitValue=val.split("/");
                        let pos=["front","random","left","right"];
                        if(splitValue.length){
                              splitValue=splitValue[splitValue.length -1];
                              let splitValueCheck=splitValue.split("_");
                              if(splitValueCheck.length){
                              if(pos.includes(splitValueCheck[splitValueCheck.length -1])){
                                   imageUrlWith=imageUrlWith.split("/");
                                   let splitLast=imageUrlWith[imageUrlWith.length -1].split("_");
                                   splitLast.pop()
                                   
                                   imageUrlWith[imageUrlWith.length -1]=splitLast.join("_");
                                   
                                   imageUrlWith=imageUrlWith.join("/");
                                   imageName=`${state.updateFormAttr.firstName}_${state.updateFormAttr.lastName}_${state.updateFormAttr.employeeId}_${splitValueCheck[splitValueCheck.length -1]}`
                                  }
                                  else{
                                    imageName=splitValue.split(".jpg")[0];
                                    imageUrlWith=`${assetUrl}${imageUrlWith}`
                                  }
                                
                              }
                              

                        }
                      }
                      
                      return <>
                    <div key={index} className="col-3 mb-2">
                      <i className="fas fa-lg fa-fw me-2 fa-trash" onClick={() => removeImage(index,true,imageName)} style={{color:"red",cursor:"pointer"}}></i>
                    <img  src={imageUrlWith} alt={imageUrlWith} style={{height: "260px",maxWidth:"260px"}}/>
                    </div>
                      </>
                    })}
                  
                  </div>
                    </div>
                  </div>
      
        </div>
          <div className="col-xl-12"style={{textAlign:"center"}}>
          <button type="submit" class="btn btn-outline-theme w-25" ref={ref} disabled={false}>Add <div className="spinner-border" role="status" style={{height:"15px",width: "1rem" ,display:"none"}}></div></button>
          </div>
     
      </div>
    </form>
  </div>

        </div>
       </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default " data-bs-dismiss="modal">Close</button>
        
      </div>
    </div>
     
     
    
  </div>
</div>


 </>
 
    
   )
}
else{
  return (<>
  <Loader/>
  </>)
}
  
}